/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Components/GenericEndpointComponents/GenericEndpointsDetailsComponents" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { InputDataType, InputValidation } from "ServiceEndpoints/Client/Contracts/FormInput_ServiceEndpoint";
import { ServiceEndpointTypes } from "ServiceEndpoints/Client/Constants/ServiceEndpoint";

import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";
import { Checkbox } from "VSSUI/Checkbox";

import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import * as Utils_String from "VSS/Core/Util/String";

export interface IGenericEndpointsDetailsComponentsProps {
    serviceEndpoint: ServiceEndpoint;
    isUpdateForm: boolean;
    updateDraftEndpointState: (serviceEndpoint: ServiceEndpoint) => void;
    updateInvalidInputsCount: (updateErrorsCountBy: number) => void;
    allowAllPipelinesFlagState?: boolean;
    updateAllowAllPipelinesFlag?: (checked: boolean) => void;
    disableAllPipelinesSetting: boolean;
}

export class GenericEndpointsDetailsComponents extends VssComponent<IGenericEndpointsDetailsComponentsProps, {}> {
    constructor(props: IGenericEndpointsDetailsComponentsProps, context: IVssComponentContext) {
        super(props, context);
        this._draftServiceEndpoint = this.props.serviceEndpoint;
        this._updateInputsErrors(this._draftServiceEndpoint.name, this._nameInputValidation, this._endpointNameErrorKey);
    }

    public UNSAFE_componentWillReceiveProps(props: IGenericEndpointsDetailsComponentsProps) {
        this._draftServiceEndpoint = props.serviceEndpoint;
        if (this.props.isUpdateForm && !this._isErrorDictInitialized) {
            this._updateInputsErrors(this._draftServiceEndpoint.name, this._nameInputValidation, this._endpointNameErrorKey);
            this._isErrorDictInitialized = true;
        }
        // TODO: remove this, handled github auto name update
        if (this._currName !== props.serviceEndpoint.name && (Utils_String.equals(props.serviceEndpoint.type, ServiceEndpointTypes.GitHub, true) || Utils_String.equals(props.serviceEndpoint.type, ServiceEndpointTypes.Bitbucket, true))) {
            this._updateInputsErrors(this._draftServiceEndpoint.name, this._nameInputValidation, this._endpointNameErrorKey);
            this._currName = props.serviceEndpoint.name;
        }
    }

    public render(): React.ReactNode {
        const error: string = this._getErrorMessage(this._endpointNameErrorKey);
        return (
            <div>
                <div className="service-connection-details-section default-input-margin-top">
                    <span role="heading" aria-level={4} className="service-endpoint-section-headers">{Resources.DetailsHeader}</span>
                    <FormItem
                        label={Resources.NameInputLabel}
                        className="default-input-margin-top"
                        error={!!error}
                        message={error}
                    >
                        <TextField
                            value={this._draftServiceEndpoint.name}
                            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string) => {
                                this._draftServiceEndpoint.name = value;
                                this._currName = value;
                                this._updateInputsErrors(value, this._nameInputValidation, this._endpointNameErrorKey);
                                this._setDirtyFlag(this._endpointNameErrorKey);
                                this.props.updateDraftEndpointState(this._draftServiceEndpoint);
                            }}
                        />
                    </FormItem>
                    <FormItem label={Resources.DescriptionInputLabel} className="default-input-margin-top">
                        <TextField
                            value={this._draftServiceEndpoint.description}
                            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string) => {
                                this._draftServiceEndpoint.description = value;
                                this._setDirtyFlag(this._endpointNameErrorKey);
                                this.props.updateDraftEndpointState(this._draftServiceEndpoint);
                            }}
                            multiline={true}
                        />
                    </FormItem>
                    <div className="pipeline-permissions-section default-input-margin-top">
                        <div className="bolt-formitem-label body-m">{Resources.SecurityHeader}</div>
                        <Checkbox
                            onChange={(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, checked: boolean) => {
                                this.props.updateAllowAllPipelinesFlag(checked);
                            }}
                            checked={this.props.allowAllPipelinesFlagState}
                            label={Resources.PipelinePermissionsCheckboxLabel}
                            disabled={this.props.disableAllPipelinesSetting}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private _updateInputsErrors(value: any, inputValidation: InputValidation, inputId: string) {
        if (!EndpointsEditorPanelUtils.isInputValid(value, inputValidation)) {
            if (!this._errorsDictionary[inputId]) {
                this.props.updateInvalidInputsCount(1);
            }
            this._errorsDictionary[inputId] = EndpointsEditorPanelUtils.getInvalidInputErrorMessage(inputValidation);
        } else {
            if (this._errorsDictionary[inputId]) {
                this.props.updateInvalidInputsCount(-1);
            }
            this._errorsDictionary[inputId] = "";
        }
    }

    private _setDirtyFlag(inputId: string) {
        this._isDirtyDictionary[inputId] = true;
    }

    private _isErrorVisible(inputId: string): boolean {
        return this._isDirtyDictionary[inputId] && !!this._errorsDictionary[inputId];
    }

    private _getErrorMessage(inputId: string): string {
        return this._isErrorVisible(inputId) ? this._errorsDictionary[inputId] : "";
    }

    private _draftServiceEndpoint: ServiceEndpoint;
    private _errorsDictionary: { [key: string]: string } = {};
    private _isDirtyDictionary: { [key: string]: boolean } = {};
    private _endpointNameErrorKey = "endpoint-name";
    private _nameInputValidation: InputValidation = {
        dataType: InputDataType.String,
        isRequired: true,
        maxLength: 200,
        maxValue: null,
        minLength: null,
        minValue: null,
        pattern: "",
        patternMismatchErrorMessage: ""
    };
    private _isErrorDictInitialized = false;
    private _currName = "";
}
